import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isEmpty, isNil} from 'lodash'
import Action from '../action'
import './actionable.scss'

class Actionable extends Component {

  getWrapperClassName = (className) => {
    const wrapper = 'actionable-actions'
    return isNil(className)
      ? wrapper
      : [wrapper, className].join(' ')
  }

  render() {
    const {className, actions, entity, entityIndex, size} = this.props

    return (
      <div className='actionable'>
        {this.props.children}
        {!isEmpty(actions) && (
          <ul className={this.getWrapperClassName(className)}>
            {actions.map((action, index) => {
              return (
                <Action
                  key={'action_' + index}
                  {...action}
                  size={size}
                  entity={entity}
                  entityIndex={entityIndex}
                />
              )
            })}
          </ul>
        )}
      </div>
    )
  }
}

Actionable.propTypes = {
  className: propTypes.string,
  children: propTypes.node,
  actions: propTypes.array,
  size: propTypes.string,
  entity: propTypes.object,
  entityIndex: propTypes.number,
}

Actionable.defaultProps = {
  className: null,
  actions: [],
}

export default Actionable
